import { fork } from 'redux-saga/effects';
import resourcesSagas from './resources.sagas';
import routesSagas from './route.sagas';
import authSagas from './auth.sagas';
import reportsSagas from './reports.sagas';

export default function* rootSaga() {
  yield [
    fork(resourcesSagas),
    fork(routesSagas),
    fork(authSagas),
    fork(reportsSagas),
  ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/index.js